import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { from, map, Observable, switchMap } from "rxjs";
import ShipmentModel from "src/app/_models/self-ship/shipping/shipment.model";
import { environment } from "src/environments/environment";
import { OrdersFetchFilters } from './self-ship-orders.service';
import { rotateIfLandscape } from "src/app/_helpers/image-utils";

const SHIPMENTS_URL = `${environment.baseUrl}/shipments`;

@Injectable()
export class ShipmentsService {

    constructor(
        private http: HttpClient
    ) { }

    public reconcilePrintedOrders() { return this.http.post(`${environment.baseUrl}/labelprintbatches/reconcile`,{}); }

    public fetchCarrierTracking(orderIds: number[]) {
        return this.http.post<any[]>(`${environment.baseUrl}/shipmenttracking/statuses`, orderIds);
    }

    public fetchPrintStatuses(orderIds: number[]) {
        return this.http.post<any[]>(`${environment.baseUrl}/labelprintbatches/order-statuses`, orderIds);
    }

    public createPrintBatch(orderIds: number[]) {
        return this.http.post<{id: number}>(`${environment.baseUrl}/labelprintbatches`, { orderIds, name: 'Prepared shipping labels' });
    }

    public fetch(filters?: OrdersFetchFilters): Observable<ShipmentModel[]> {
        return this.http.get<ShipmentModel[]>(SHIPMENTS_URL, { params: filters }).pipe(
            switchMap(shipments => from(this._processShipmentLabels(shipments)).pipe(map(() => shipments)))
        );
    }

    public fetchByOrderId(orderId: number, includeLabel: boolean = false): Observable<ShipmentModel[]> {
        return this.http.get<ShipmentModel[]>(`${SHIPMENTS_URL}/ShipmentsByOrderId/${orderId}`, { params: { includeLabel } as any }).pipe(
            switchMap(shipments => includeLabel
                ? from(this._processShipmentLabels(shipments)).pipe(map(() => shipments))
                : from(Promise.resolve()).pipe(map(() => shipments))
            )
        );
    }

    public generateLabelsForOrderBoxes(boxIds: number[]) {
        return this.http.post<any>(`${SHIPMENTS_URL}/generateLabelsForOrderBoxes`, boxIds);
    }

    public voidLabelsForOrderBoxes(boxIds: number[]) {
        return this.http.post<any>(`${SHIPMENTS_URL}/voidLabelsForOrderBoxes`, boxIds);
    }

    private async _processShipmentLabels(shipments: ShipmentModel[]): Promise<void> {
        try {
            await Promise.all(shipments.map(async (shipment) => {
                await Promise.all(shipment.shippingLabels.map(async label => {
                    label.label = await rotateIfLandscape(label.label);
                }));
            }));
        } catch (error) {
            console.error(error);
        }
    }
}
